import { useEffect, useState } from 'react';
import { useAdminFilters } from '../../contexts/AdminFiltersContext';

export default function useAdminData(fetcher, extraQuery = '') {
  const filters = useAdminFilters();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const base = filters.asQuery();
    const query = extraQuery ? `${base}${base ? '&' : ''}${extraQuery}` : base;
    Promise.resolve(fetcher(query))
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.from, filters.to, filters.market, extraQuery]);

  return { data, loading, error };
}
